import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  label: 'Resumen de un PDF largo',
  sin: '4-6 horas',
  con: '40 minutos'
}, {
  label: 'Preparar un parcial',
  sin: 'Rezás y esperás',
  con: 'Simulacro personalizado'
}, {
  label: 'Organizar el cuatrimestre',
  sin: 'Domingo armando cronogramas',
  con: 'Plan listo en 10 min'
}, {
  label: 'Hacer un TP',
  sin: 'Noche entera bloqueado/a',
  con: '2 horas estructurado'
}, {
  label: 'Estudiar con pánico',
  sin: 'Siempre',
  con: 'Nunca más'
}];
export function Comparativa() {
  return <section className="bg-[#0C1220] py-[60px] md:py-[80px]" data-id="element-44">
      <div className="max-w-[800px] mx-auto px-5" data-id="element-45">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[clamp(28px,5vw,42px)] font-black text-center leading-[1.2] mb-10" data-id="element-46">
          Sin sistema vs Con sistema
        </motion.h2>

        {/* Desktop Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="hidden md:block bg-navy-2 border border-brand-blue-dark rounded-xl overflow-hidden" data-id="element-47">
          <div className="grid grid-cols-3 bg-navy-3 border-b border-brand-blue-dark" data-id="element-48">
            <div className="p-5 font-bold text-brand-gray text-[13px] uppercase tracking-[1px]" data-id="element-49">
              Situación
            </div>
            <div className="p-5 font-bold text-[#FF5F57] text-[13px] uppercase tracking-[1px] border-l border-brand-blue-dark bg-[#FF5F57]/5" data-id="element-50">
              ❌ Sin sistema
            </div>
            <div className="p-5 font-bold text-brand-success text-[13px] uppercase tracking-[1px] border-l border-brand-blue-dark bg-brand-success/5" data-id="element-51">
              ✅ Con sistema
            </div>
          </div>
          {rows.map((row, i) => <div key={i} className="grid grid-cols-3 border-b border-brand-blue-dark/50 last:border-0" data-id="element-52">
              <div className="p-5 text-[15px] font-medium text-white flex items-center" data-id="element-53">
                {row.label}
              </div>
              <div className="p-5 text-[15px] text-brand-gray border-l border-brand-blue-dark/50 bg-[#FF5F57]/5 flex items-center" data-id="element-54">
                {row.sin}
              </div>
              <div className="p-5 text-[15px] font-bold text-brand-gold border-l border-brand-blue-dark/50 bg-brand-success/5 flex items-center" data-id="element-55">
                {row.con}
              </div>
            </div>)}
        </motion.div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col gap-4" data-id="element-56">
          {rows.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-navy-2 border border-brand-blue-dark rounded-xl overflow-hidden" data-id="element-57">
              <div className="bg-navy-3 p-4 border-b border-brand-blue-dark text-[15px] font-bold text-white text-center" data-id="element-58">
                {row.label}
              </div>
              <div className="grid grid-cols-2 divide-x divide-brand-blue-dark" data-id="element-59">
                <div className="p-4 bg-[#FF5F57]/5 flex flex-col items-center text-center gap-1" data-id="element-60">
                  <span className="text-[11px] font-bold text-[#FF5F57] uppercase tracking-[1px]" data-id="element-61">
                    ❌ Sin sistema
                  </span>
                  <span className="text-[14px] text-brand-gray" data-id="element-62">{row.sin}</span>
                </div>
                <div className="p-4 bg-brand-success/5 flex flex-col items-center text-center gap-1" data-id="element-63">
                  <span className="text-[11px] font-bold text-brand-success uppercase tracking-[1px]" data-id="element-64">
                    ✅ Con sistema
                  </span>
                  <span className="text-[14px] font-bold text-brand-gold" data-id="element-65">
                    {row.con}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}